import type { UserShowQueryType } from "@/types/graphql/admin.generated";
import { UserDetails } from "../UserDetails";

export const UserShowComponent: React.ComponentType<{
  editData?: unknown;
  user?: UserShowQueryType["user"];
}> = ({ user }) => {
  if (!user) return <div>Загрузка...</div>;

  return <UserDetails user={user} />;
};
